import useReveal from '../hooks/useReveal';

/** Envolve um bloco para ele entrar com fade + deslocamento vertical ao
 *  cruzar a viewport. `stagger` é o índice do item numa lista de irmãos: cada
 *  posição ganha 70ms a mais de atraso, para a entrada ler como cascata em
 *  vez de tudo aparecendo junto. */
function Reveal({ as: Tag = 'div', heavy = false, stagger = 0, className = '', style, children, ...props }) {
  const [ref, reveal] = useReveal();

  const classes = [reveal, heavy ? 'reveal--heavy' : '', className].filter(Boolean).join(' ');

  return (
    <Tag
      ref={ref}
      className={classes}
      style={reveal ? { ...style, transitionDelay: `${stagger * 70}ms` } : style}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
